import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gray-200 text-start">
      <div className="text-black font-semibold text-sm text-center py-2 flex max-sm:block justify-around items-center max-sm:space-y-1">
        <p>Contact: <a href="tel:7305952831">7305952831</a> / <a href="tel:9884807480">9884807480</a>.</p>
        <p>&copy; {new Date().getFullYear()} MHC Global. All rights reserved.</p>
        <div className='flex justify-center items-center text-blue-600 underline underline-offset-1'>
          <a href='/privacy-policy'>Privacy Policy.</a>
        </div>
        <div className='flex justify-center items-center text-blue-600 underline underline-offset-1'>
          <a href='/terms-and-conditions'>Terms and conditions.</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
